import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { PurestComponent } from '../../../../PurestComponent';
import { MetabaseFrame } from './MetabaseFrame';

const styles = () => ({
    root: {
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
        '@media (max-width: 553px)': {
            flexDirection: 'column-reverse',
            alignItems: 'center',
            maxWidth: 350
        }
    },
    iframe: {
        height: 800,
        width: 950
    }
});

class DashboardPageComponent extends PurestComponent {

    constructor(props) {
        super(props);
        this.classes = this.props.classes;
    }

    render() {
        return (
            <MetabaseFrame
                title='dashboard'
                id={1}
                className={this.classes.iframe}
                type='dashboard'
                location={this.props.location}
                history={this.props.history}
            />
        );
    }
}

DashboardPageComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export const DashboardPage = withStyles(styles)(DashboardPageComponent);
